export default {
  camposDinamicos: state => state.camposDinamicos
};
